import { effects } from 'redux-saga'

import {
  FETCH_SUGGESTIONS,
  beginWork,
  endWork,
  receiveSuggestions,
} from '../../modules/autocomplete'

export default function* autocomplete(
  delay,
  handlers,
) {
  yield effects.throttle(
    delay,
    FETCH_SUGGESTIONS,
    runHandler,
    handlers,
  )
}

export function* runHandler(handlers, action) {
  const handler = handlers[action.payload.type]
  if (!handler) {
    throw new Error(`No handler configured for ${action.payload.type}`)
  }

  if (!action.payload.query) {
    return
  }

  const state = yield effects.select()
  if (state.autocomplete.hasIn([
    'suggestions',
    action.payload.type,
    action.payload.query,
  ])) {
    // We already have values
    // TODO: handle result age

    return
  }

  try {
    yield effects.put.resolve(beginWork(action.payload.type))
    const results = yield effects.call(handler, action)

    yield effects.put.resolve(receiveSuggestions(
      action.payload.type,
      action.payload.query,
      results,
    ))
  } finally {
    yield effects.put.resolve(endWork(action.payload.type))
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/autocomplete/index.js